<script setup lang="ts">
import { computed, useAttrs } from 'vue'

defineOptions({
  inheritAttrs: false,
})
const props = defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
  isActive: {
    type: Boolean,
    default: false,
  },
  isAnimated: {
    type: Boolean,
    default: false,
  },
  isNeutral: {
    type: Boolean,
    default: false,
  },
  isWhite: {
    type: Boolean,
    default: false,
  },
  loader: {
    type: Boolean,
    default: false,
  },
  size: {
    type: String,
    default: 'md',
    validator: (value: string) => {
      const sizeList: string[] = ['sm', 'md', 'lg', 'xl']

      return sizeList.includes(value)
    },
  },
})

const emit = defineEmits(['click'])
const attrs = useAttrs()

const component = computed(() => {
  if (attrs.to) {
    return 'router-link'
  } else if (attrs.href) {
    return 'a'
  }

  return 'button'
})
const classSizes = computed(() => {
  if (props.size === 'sm') {
    return 'py-1 px-2'
  } else if (props.size === 'lg') {
    return 'py-6 px-12'
  } else if (props.size === 'xl') {
    return 'py-8 px-12'
  }

  return 'py-3 px-6'
})
const onClick = (e: Event) => {
  emit('click', e)
}
</script>

<template>
  <component
    :is="component"
    :class="[
      'mx-auto flex w-full items-center justify-center rounded-sm border font-medium transition-all focus:outline-none',
      { 'button-primary': !disabled && isActive && !isWhite },
      { 'text-button text-xl': !isWhite },
      { 'button-secondary': !disabled && !isActive && !isNeutral && !isWhite },
      { 'border-none text-gray-500': isNeutral },
      { 'border-gray-400 text-gray-400': isWhite },
      { 'bg-gray-200': disabled },
      { 'hover:scale-110 hover:opacity-90': isAnimated },
      classSizes,
    ]"
    v-bind="$attrs"
    @click="onClick"
  >
    <span v-if="loader" class="loader">
      <i class="loader__spin" />
    </span>

    <slot />
  </component>
</template>

<style scoped>
button[disabled] {
  @apply bg-gray-200;
}

/* Btn Loader */
.loader {
  @apply w-5 h-5 inline-block relative align-middle mr-4;
}
.loader__spin {
  transform: rotate(0deg);
  animation: spinBaseButton 1s linear infinite;
  @apply absolute inset-1/2 w-5	h-5 rounded-full;
}
@keyframes spinBaseButton {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}
</style>
